import React from 'react'
import shaka from 'shaka-player'
import mux from 'mux.js'

export default class ShakaPlayerComponent extends React.Component {
    componentDidMount() {
        window.muxjs = mux;
        shaka.polyfill.installAll();
        if (shaka.Player.isBrowserSupported()) {
            const video = document.getElementById('video');
            const player = new shaka.Player(video);
            player.configure({
                    'preferredTextLanguage': 'es',
                    'streaming': {
                    'jumpLargeGaps': true
                }});
            window.playerShaka = player;
            this.initPlayer();
        } else {
            console.error('Browser not supported!');
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.url !== this.props.url){
            this.initPlayer(true,nextProps.url);
        }
    }
    initPlayer(kill,url){
        playerShaka.addEventListener('error', this.onErrorEvent);
        if(kill){
            playerShaka.unload();
            console.log('The Url is:'+url)
            playerShaka.load(url).then(function() {
                console.log('The video has now been loaded!');
            }).catch(err=>{
                    this.onError(err);
                    console.log('err 1')
                    console.log(err)
                }
            );
        }
        else{
            console.log('The Url is:'+this.props.url)
            playerShaka.load(this.props.src).then(function() {
                console.log('The video has now been loaded!');
            }).catch(err=>{
                this.onError(err);
                console.log('err 2')
                console.log(err)
            });
        }

    }
    onErrorEvent = (event) =>{
        this.props.errorHandler(event)
        this.onError(event.detail);
    }

    onError(error) {
        console.log('Error occured2')
        console.error('Error code', error.code, 'object', error);
    }

    componentWillUnmount() {
        playerShaka.unload(this.props.url).then(function() {
            console.log('The video has now been stopped!');
        }).catch(err=>{
        })

    }
    render() {
        const {poster, width = '100%', height = '100%'} = this.props;
        return (
                <video id='video'
                       width={width}
                       height={height}
                       poster={poster}
                       controls
                       autoPlay
                >
                </video>

        );
    }
}